import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";
import config from "../config/config";

export const AppContext = createContext();

const AppContextProvider = ({ children }) => {
  const loginuserid = localStorage.getItem("ID");
  const UserRole = localStorage.getItem("QB");
  console.log(UserRole, "410501");
  const token = localStorage.getItem("Token");

  const [getValueString, setGetValueString] = useState();
  const [getdDeleteTableRows, setGetDeleteTableRows] = useState();
  const [fetchBrand, setFetchBrand] = useState();
  const [itemVariations, setItemVariations] = useState();
  const [CurrencySymbol, setCurrencySymbol] = useState();
  const [FractionDigits, setFractionDigits] = useState();
  const [mailingAddress, setMailingAddress] = useState("");
  const [mailingAdd, setMailingAdd] = useState({
    mail: "",
  });
  const [autoGeneration, setAutoGeneration] = useState();
  const [Label, setLabel] = useState(false);
  const [UserRoles, setUserRole] = useState(UserRole);
  const [itemdata, setitemdata] = useState([]);
  const [IDsarray, setIDarray] = useState([]);
  const [missingtransactions, setmissingtransaction] = useState(false);
  // const [UserRoles, setUserRole] = useState(UserRole);
  // const [itemdata, setitemdata] = useState([]);
  // const [IDsarray, setIDarray] = useState([]);
  const [isManageSale, setIsManageSale] = useState();
  const [isTax, setIsTax] = useState(false);
  const [isManagePOSSale, setIsManagePOSSale] = useState();
  const [isManageReceiving, setIsManageReceiving] = useState();
  const [isManagePOSReceiving, setIsManagePOSReceiving] = useState();
  const [filterData, setFilterData] = useState([]);
  const [dateFormate, setDateFormate] = useState("");
  const [currencyValues, setCurrencyValues] = useState([]);
  const [registerConfig, setRegisterConfig] = useState([]);
  const [registerId, setRegisterId] = useState(0);
  const [closeRegiterSummaryValidation, setCloseRegiterSummaryValidation] =
    useState(false);
  const [currencySymbolLocation, setCurrencySymbolLocation] = useState("");
  const [showEmployeeRegister, setShowEmployeeRegister] = useState(false);
  const [showPosTakePayment, setShowTakePayment] = useState(false);
  const [showTemporaryActivatedItems, setShowTemporaryActivatedItems] =
    useState(false);

  // QuickBook Permission

  const [SaleQuickPermision, setSaleQuickPermision] = useState(false);
  const [RecevingsQuickPermision, setRecevingsQuickPermision] = useState(false);
  const [
    InventoryAdjustmentQuickPermision,
    setInventoryAdjustmentQuickPermision,
  ] = useState(false);

  const [QuickBookJournalEntry, setQuickBookJournalEntry] = useState(false);
  const [QuickBookBankTransfer, setQuickBookBankTransfer] = useState(false);
  const [QuickBookBankDeposit, setQuickBookBankDeposit] = useState(false);
  const [QuickBookViewRagister, setQuickBookViewRagister] = useState(false);
  const [QuickBookItems, setQuickBookItems] = useState(false);
  const [QuickBookCustomers, setQuickBookCustomers] = useState(false);
  const [QuickBookVendors, setQuickBookVendors] = useState(false);
  const [QuickBookExpense, setQuickBookExpense] = useState(false);
  const [AllowQBSync, setAllowQBSync] = useState(false);
  const [QuickBookPaymentMethod, setQuickBookPaymentMethod] = useState(false);
  const [ReportViewPermission, setReportViewPermission] = useState(false);
  const [enableAOSForItemAndVariation, setEnableAOSForItemAndVariation] = useState(false);
  const [enableAutoSuggestCreditReceivePayment, setEnableAutoSuggestCreditReceivePayment] = useState(false);
  const [enableAutoSuggestCreditBillPayment, setEnableAutoSuggestCreditBillPayment] = useState(false);
  const [enableRecallPrice, setEnableRecallPrice] = useState(false);

  console.log(showPosTakePayment, "showPosTakePayment");

  useEffect(() => {
    axios
      .get(
        `${config.quickbooksBaseUrl}/quickbooks/gettoken?loginuserid=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )

      .then((res) => {
        const data = res.data.ResponseData[0];
        if (data.Isconnected == 1) {
          setLabel(true);
        } else {
          setLabel(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const fetchData = () => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Appconfigdata`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      })
      // .then((res) => {
      //   // console.log(res, "4522001125000003214")
      //   let currencysymbol = res.data.ResponseData?.filter(
      //     (item) => item.AppConfigkey == "CurrencySymbol"
      //   );

      //   let FractionDigits = res.data.ResponseData?.filter(
      //     (item) => item?.AppConfigkey == "NumberOfDecimals"
      //   );

      //   let DateFormate = res.data.ResponseData?.filter(
      //     (item) => item?.AppConfigkey == "DateFormat"
      //   );

      //   let enableEmpRegister = res.data.ResponseData?.filter(
      //     (item) => item?.AppConfigkey == "EnableEmployeeRegister"
      //   );

      //   // Extract CurrencyLabel1 to CurrencyLabel20
      //   let currencyLabels = res.data.ResponseData
      //   .filter(item => item.AppConfigkey.startsWith("CurrencyLabel"))
      //   .sort((a, b) => {
      //     // Extract numeric part from "CurrencyLabelX"
      //     let numA = parseInt(a.AppConfigkey.replace("CurrencyLabel", ""), 10);
      //     let numB = parseInt(b.AppConfigkey.replace("CurrencyLabel", ""), 10);
      //     return numA - numB;
      //   })
      .then((res) => {
        // console.log(res, "4522001125000003214")
        let currencysymbol = res.data.ResponseData?.filter(
          (item) => item.AppConfigkey == "CurrencySymbol"
        );

        let FractionDigits = res.data.ResponseData?.filter(
          (item) => item?.AppConfigkey == "NumberOfDecimals"
        );

        let DateFormate = res.data.ResponseData?.filter(
          (item) => item?.AppConfigkey == "DateFormat"
        );

        let enableEmpRegister = res.data.ResponseData?.filter(
          (item) => item?.AppConfigkey == "EnableEmployeeRegister"
        );

        let enablePosTakePayment = res.data.ResponseData?.filter(
          (item) => item?.AppConfigkey == "EnablePosTakePayment"
        );

        let showTemporaryActivatedItems = res.data.ResponseData?.filter(
          (item) => item?.AppConfigkey == "ShowTemporaryActivatedItems"
        );
        // QuickBook Sync Permission
        let QuickBookPermissionsale = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "Sale"
        );

        let QuickBookPermissionRecevings = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "Recevings"
        );

        let QuickBookPermissionInventoryAdjustment =
          res.data.ResponseData?.find(
            (item) => item?.AppConfigkey == "InventoryAdjustment"
          );

        let QuickBookJournalEntry = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "JournalEntry"
        );

        let QuickBookBankTransfer = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "BankTransfer"
        );



        let QuickBookbankDeposit = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "bankDeposit"
        );

        let QuickBookViewRagister = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "ViewRagister"
        );

        let QuickBookItems = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "Items"
        );

        let QuickBookCustomers = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "Customer"
        );
        let QuickBookVendors = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "Supplier"
        );


        let QuickBookExpense = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "Expense"
        );

        let QuickSyncAllow = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "AllowQBSync"
        );

        let AllowQuickBookPaymentMethod = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "PaymentMethod"
        );

        let ReportViewpermission = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "ReportView"
        );

        let getRecallEnable = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "Portal Recall Price Settings"
        );

        let AOSEnableForItemAndVariation = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "AOSEnableForItemAndVariation"
        );
       
        let AutoSuggestCreditBillPayment = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "AutoSuggestCreditBillPayment"
        );
       
        let AutoSuggestCreditReceivePayment = res.data.ResponseData?.find(
          (item) => item?.AppConfigkey == "AutoSuggestCreditReceivePayment"
        );

        console.log(ReportViewpermission, "ReportViewpermission");
        
        setEnableAutoSuggestCreditBillPayment(
          AutoSuggestCreditBillPayment?.AppConfigvalue == "true" ? true : false);
        
        setEnableAutoSuggestCreditReceivePayment(
          AutoSuggestCreditReceivePayment?.AppConfigvalue == "true" ? true : false);
        
        setEnableAOSForItemAndVariation(
          AOSEnableForItemAndVariation?.AppConfigvalue == "true" ? true : false);

        setReportViewPermission(
          ReportViewpermission?.AppConfigvalue == "true" ? true : false);

        setEnableRecallPrice(
          getRecallEnable?.AppConfigvalue == 1 ? true : false);

        setSaleQuickPermision(
          QuickBookPermissionsale?.AppConfigvalue == "true" ? true : false
        );
        setRecevingsQuickPermision(
          QuickBookPermissionRecevings?.AppConfigvalue == "true" ? true : false
        );
        setInventoryAdjustmentQuickPermision(
          QuickBookPermissionInventoryAdjustment?.AppConfigvalue == "true"
            ? true
            : false
        );

        setQuickBookJournalEntry(
          QuickBookJournalEntry?.AppConfigvalue == "true" ? true : false
        );

        setQuickBookBankTransfer(
          QuickBookBankTransfer?.AppConfigvalue == "true" ? true : false
        );

        setQuickBookBankDeposit(
          QuickBookbankDeposit?.AppConfigvalue == "true" ? true : false
        );

        setQuickBookViewRagister(
          QuickBookViewRagister?.AppConfigvalue == "true" ? true : false
        );

        setQuickBookItems(
          QuickBookItems?.AppConfigvalue == "true" ? true : false
        );
        setQuickBookCustomers(
          QuickBookCustomers?.AppConfigvalue == "true" ? true : false
        );
        setQuickBookVendors(
          QuickBookVendors?.AppConfigvalue == "true" ? true : false
        );


        setQuickBookExpense(
          QuickBookExpense?.AppConfigvalue == "true" ? true : false 
        );

        setAllowQBSync(
          QuickSyncAllow?.AppConfigvalue == "true" ? true : false 
        );

        setQuickBookPaymentMethod(
          AllowQuickBookPaymentMethod?.AppConfigvalue == "true" ? true : false 
        );

        // Extract CurrencyLabel1 to CurrencyLabel20
        let currencyLabels = res.data.ResponseData.filter((item) =>
          item.AppConfigkey.startsWith("CurrencyLabel")
        )
          .sort((a, b) => {
            // Extract numeric part from "CurrencyLabelX"
            let numA = parseInt(
              a.AppConfigkey.replace("CurrencyLabel", ""),
              10
            );
            let numB = parseInt(
              b.AppConfigkey.replace("CurrencyLabel", ""),
              10
            );
            return numA - numB;
          })
          .map((item) => item.AppConfigvalue);

        // take keys to show in data
        let registerConfigs = res.data.ResponseData.filter((item) =>
          item.AppConfigkey.toLowerCase().endsWith("register")
        );

        let manageSale = res.data.ResponseData?.filter(
          (item) =>
            item.Type == "PERMISSION" && item.AppConfigkey === "SaleEdit"
        );

        let Taxpermission = res.data.ResponseData?.filter(
          (el) => el.Type == "TAXES" && el.AppConfigkey === "IsTaxunableKey"
        );
        let managePOSSale = res.data.ResponseData?.filter(
          (item) => item.Type == "PERMISSION" && item.AppConfigkey === "POSEdit"
        );

        let registerId = res.data.ResponseData?.filter(
          (item) =>
            item.Type == "REGISTER" && item.AppConfigkey === "RegisterId"
        );

        let closeRegisterValidation = res.data.ResponseData?.filter(
          (item) =>
            item.Type == "SALES" &&
            item.AppConfigkey ===
              "DoNotShowExpectedClosingAmountWhenClosingRegister"
        );
        let getcurrencySymbolLocation = res.data.ResponseData?.filter(
          (item) => item.AppConfigkey == "CurrencySymbolLocation"
        );

        const permissions =
          res.data.ResponseData?.filter(
            (item) => item.Type === "RECVPERMISSION"
          ) || [];

        const getPermissionValue = (key) =>
          permissions.find((item) => item.AppConfigkey === key)?.AppConfigvalue;

        setIsManageReceiving(getPermissionValue("ReceivingEdit"));
        setIsManagePOSReceiving(getPermissionValue("ReceivingPOSEdit"));

        setIsManageSale(manageSale[0]?.AppConfigvalue);
        setIsTax(Taxpermission[0]?.AppConfigvalue);
        setIsManagePOSSale(managePOSSale[0]?.AppConfigvalue);
        setDateFormate(DateFormate[0]?.AppConfigvalue);
        setShowEmployeeRegister(enableEmpRegister[0]?.AppConfigvalue);
        setShowTakePayment(enablePosTakePayment[0]?.AppConfigvalue);
        setShowTemporaryActivatedItems(
          showTemporaryActivatedItems[0]?.AppConfigvalue
        );
        setCurrencySymbol(currencysymbol[0]?.AppConfigvalue);
        setFractionDigits(FractionDigits[0]?.AppConfigvalue);
        setCurrencyValues(currencyLabels);
        setRegisterConfig(registerConfigs);
        setCloseRegiterSummaryValidation(
          closeRegisterValidation[0]?.AppConfigvalue
        );
        console.log(closeRegisterValidation[0]?.AppConfigvalue, "deffh");
        setRegisterId(registerId[0]?.AppConfigvalue);
        if (registerId[0]?.AppConfigvalue) {
          localStorage.setItem("registerId", registerId[0]?.AppConfigvalue);
        }

        setCurrencySymbolLocation(getcurrencySymbolLocation[0]?.AppConfigvalue);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log(isManageSale, isManagePOSSale, "410501");
  const valueStringFunction = (event) => {
    console.log(getValueString);
    setGetValueString({ ...getValueString, event });
  };

  const deleteTableRowsFunction = (event) => {
    console.log(getValueString);
    setGetDeleteTableRows({ ...getdDeleteTableRows, event });
  };

  const fetchBrandFunction = (event) => {
    console.log(getValueString);
    setFetchBrand({ ...fetchBrand, event });
  };

  const fetchItemVariation = (event) => {
    console.log(getValueString);
    setItemVariations({ ...itemVariations, event });
  };

  const updateMail = (mail) => {
    console.log(mailingAdd, "fffffffffffffffffff");
    setMailingAdd({ mail });
  };

  const autoGenerationFunction = (event) => {
    console.log(mailingAdd, "fffffffffffffffffff");
    setAutoGeneration({ ...autoGeneration, event });
  };

  const userdata = (data) => {
    console.log(data, "410501");
  };

  const resposeIds = (ID) => {
    console.log(ID, "arraydata");
    setIDarray(ID);
  };

  const ItemIds = async (data) => {
    console.log(data, "5555");

    let res = await axios.get(
      `${config.itemsBaseUrl}/items/iteminfofindbyid?id=${data > 0 ? data : 0}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      }
    );

    console.log(res.data.ResponseData, "5555");
    setitemdata(res.data.ResponseData);
  };

  const missingtransaction = (obj) => {
    console.log(obj, "missing");
    if (obj.Module && obj.Id) {
      axios
        .get(
          `${config.storeConfigBaseUrl}/storeconfig/missingtransaction?Module=${obj?.Module}&ID=${obj?.Id}`
        )
        .then((res) => {
          console.log(res.data.ResponseData[0].IsDeleted == 1, "5454");

          setmissingtransaction(res.data.ResponseData[0].IsDeleted == 1);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <AppContext.Provider
      value={{
        valueStringFunction,
        deleteTableRowsFunction,
        fetchBrandFunction,
        fetchItemVariation,
        updateMail,
        autoGenerationFunction,
        mailingAddress,
        setMailingAddress,
        Label,
        userdata,
        ItemIds,
        itemdata,
        UserRoles,
        resposeIds,
        IDsarray,
        CurrencySymbol,
        missingtransaction,
        missingtransactions,
        setmissingtransaction,
        FractionDigits,
        isManagePOSSale,
        isManageSale,
        isTax,
        fetchData,
        dateFormate,
        currencyValues,
        registerConfig,
        registerId,
        closeRegiterSummaryValidation,
        currencySymbolLocation,
        isManageReceiving,
        isManagePOSReceiving,
        showEmployeeRegister,
        showPosTakePayment,
        showTemporaryActivatedItems,
        SaleQuickPermision,
        RecevingsQuickPermision,
        InventoryAdjustmentQuickPermision,
        QuickBookJournalEntry,
        QuickBookBankTransfer,
        QuickBookBankDeposit,
        QuickBookViewRagister,
        QuickBookVendors,
        QuickBookItems, 
        QuickBookCustomers,
        QuickBookExpense, 
        AllowQBSync, 
        QuickBookPaymentMethod,
        ReportViewPermission,
        enableAOSForItemAndVariation,
        showTemporaryActivatedItems,
        enableRecallPrice,
        enableAutoSuggestCreditBillPayment,
        enableAutoSuggestCreditReceivePayment
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
